<template>
  <div>
    <v-select
      :label="$t('addShooting.selectStamp')"
      v-model="selectedStamp"
      return-object
      item-value="id"
      item-text="name"
      :items="stamps"
      clearable
      @input="update"
      :rules="select"
      :loading="loading"
      :disabled="loading"
    ></v-select>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SelectStamp',

  computed: {
    ...mapState({
      format: state => state.newShooting.format,
      stamps: state => state.stamps
    }),
    ...mapGetters(['userId']),
    select() {
      return [v => !!v || this.$t('rooms.form.required')]
    }
  },

  data() {
    return {
      loading: false,
      selectedStamp: null
    }
  },

  created() {
    this.getStamps(this.userId, this.format)
  },

  methods: {
    async getStamps(userId, format) {
      this.loading = true
      const res = await this.$store.dispatch('getStamps', { userId, format })

      if (res) this.loading = false
    },
    update(val) {
      this.$store.commit('UPDATE_STAMP', val)
    }
  },

  watch: {
    format(newVal, oldVal) {
      this.selectedStamp = null
      this.$store.commit('UPDATE_STAMP', null)
      this.getStamps(this.userId, newVal)
    }
  }
}
</script>

<style lang="sass" scoped>
p
  text-align: center
  font-size: 16px
  color: rgba(0, 0, 0, 0.7)
</style>
